import React from 'react'
import PropTypes from 'prop-types'
import Popup from 'reactjs-popup'

const PopupWrapper = ({ children, options, trigger }) => (
  <Popup
    {...options}
    trigger={trigger}
  >
    <div className="popup-content">
      {children}
    </div>
  </Popup>
)

PopupWrapper.defaultProps = {
  options: {
    closeOnDocumentClick: true,
    position: "right center",
    arrow: true,
    on: "hover",
    contentStyle: {
      padding: '0',
      backgroundColor: 'transparent',
      border: 'none',
      boxShadow: 'none',
      borderRadius: null
    }
  }
}

PopupWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  trigger: PropTypes.node.isRequired
}

export default PopupWrapper
